import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["sidebar", "chevronDown", "chevronUp"]

  toggle() {
    this.sidebarTarget.classList.toggle('hidden')
    this.chevronDownTarget.classList.toggle('hidden')
    this.chevronUpTarget.classList.toggle('hidden')
  }

  // Ensure the filters sidebar stays open when filters are applied
  keepOpen() {
    if (this.sidebarTarget.classList.contains('hidden')) {
      this.sidebarTarget.classList.remove('hidden')
      this.chevronDownTarget.classList.add('hidden')
      this.chevronUpTarget.classList.remove('hidden')
    }
  }
} 
